import React, { FC, ReactNode, useEffect, useMemo, useState } from 'react';
import styles from '../../../TopNavBar.module.scss';
import { Currency } from 'shared/components/CurrencySelect/types';
import { Spinner } from 'reactstrap';
import { palette } from 'shared/constants/colorsConstants';
import { GenerateIcon, ICONS } from '@pileus-cloud/anodot-frontend-common';
import { useCurrencyContext } from 'app/contexts/Currency/CurrencyContext';
import { FeatureNotActivated } from './FeatureNotActivatedButton';
import moment from 'moment';
import { PageShownInProviderCurrencyWarningOverlay } from './PageShownInProviderCurrencyWarningOverlay';

interface FeatureNotSupportedButton {
  selectedCurrency: Currency | null;
}

export const FeatureNotSupportedButton: FC<FeatureNotSupportedButton> = ({
  selectedCurrency,
}: FeatureNotSupportedButton): ReactNode => {
  const currencyContext = useCurrencyContext();
  const [isHovered, setIsHovered] = useState(false);
  const shouldShowProviderWarning = useMemo(() => {
    const processingCurrencyDate = moment(currencyContext.processingCurrencyUpdateTime).toDate();
    const currentDate = moment();
    const twoWeeksInMilliseconds = moment.duration(2, 'weeks').asMilliseconds();
    const isWithinTwoWeeks = currentDate.diff(processingCurrencyDate) <= twoWeeksInMilliseconds;
    if (isWithinTwoWeeks) {
      return true;
    }
    return false;
  }, [currencyContext.processingCurrencyUpdateTime]);

  const [showProviderWarning, setShowProviderWarning] = useState(shouldShowProviderWarning);

  useEffect(() => {
    if (shouldShowProviderWarning) {
      setShowProviderWarning(true);
      const timer = setTimeout(() => {
        setShowProviderWarning(false);
      }, 2000);

      return () => clearTimeout(timer);
    }
  }, [shouldShowProviderWarning]);

  const showUnActiveFeatureForMatchingCurrencies = useMemo(() => {
    return currencyContext.providerCurrency === currencyContext.processingCurrency;
  }, [currencyContext]);

  if (showUnActiveFeatureForMatchingCurrencies) {
    return <FeatureNotActivated selectedCurrency={selectedCurrency} />;
  }
  return (
    <div
      className={`${styles.roundButton} ${styles.currencyButton}`}
      onMouseEnter={(e) => {
        e.stopPropagation();
        setIsHovered(true);
      }}
      onMouseLeave={(e) => {
        e.stopPropagation();
        setIsHovered(false);
      }}
    >
      {selectedCurrency ? (
        <div className={styles.notSupported}>
          <GenerateIcon className={styles.indicator} iconName={ICONS.circleExclamation.name} />
          <div>
            {selectedCurrency?.code} ({selectedCurrency?.symbolNative})
          </div>
        </div>
      ) : (
        <Spinner position="relative" size={20} color={palette.blue[500]} />
      )}
      {(isHovered || showProviderWarning) && (
        <div className={styles.modalParentClass}>
          <PageShownInProviderCurrencyWarningOverlay />
        </div>
      )}
    </div>
  );
};
